export const DEFAULT_CLEANING_DURATION_MINUTES = 30;
export const DEFAULT_CHARGING_DURATION_MINUTES = 15;

// Slower than dnd-kit's 200ms default so the check/uncheck reorder reads as a deliberate move.
export const CLEANING_AREA_LIST_SORTABLE_TRANSITION = { duration: 350, easing: 'ease' };

// Under 2 min: up-to-date; 2 to 5 whole minutes: "<x> minutes ago"; from 6 min: date and time.
export const SYNC_STATUS_UP_TO_DATE_MS = 120_000;
export const SYNC_STATUS_MINUTES_AGO_LIMIT_MS = 360_000;
export const SYNC_STATUS_REFRESH_INTERVAL_MS = 30_000;
